const _sans = ["Geist","sans-serif","Geist","sans-serif"]
const _rubik = ["Rubik","sans-serif","Rubik","sans-serif"]
const config = { "sans": _sans, "rubik": _rubik,  }
export { config as default, _sans, _rubik }